import React from "react"
//import I18n from "i18n-js/index.js.erb"
import ModalButtons from "../ModalButtons/ModalButtons"
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner"
import EmailCampaignBuilderNavSteps from "./EmailCampaignBuilderNavSteps"
import EmailCampaignBuilderWorkspace from "./EmailCampaignBuilderWorkspace"

export default class EmailCampaignBuilder extends React.Component{
  constructor(props){
    super(props);
    this.state = {
      step: 'general',
      allowStepNavigation: false,
      loading: false,
      errors: [],
      email_campaign: this.props.email_campaign,
      all_emails: this.props.all_emails,
      emailFields: this.props.email_fields || {},
      emailTriggers: this.props.email_triggers,
      allCustomerFields: this.props.all_customer_fields,
      customerFields: this.props.customer_fields || {},
      customerSelectBoxes: [],
      emailSelectBoxes: [],
      customers: this.props.customers,
      table_data: this.props.table_data || []
    };
    this.onChange = this.onChange.bind(this)
    this.onChangeEmails = this.onChangeEmails.bind(this)
    this.onChangeInput = this.onChangeInput.bind(this)
    this.onChangeSelect = this.onChangeSelect.bind(this)
    this.onChangeAdditionalQuestionsSelect = this.onChangeAdditionalQuestionsSelect.bind(this)
    this.onChangeCustomerFieldDate = this.onChangeCustomerFieldDate.bind(this)
    this.onChangeNumberField = this.onChangeNumberField.bind(this)
    this.onChangeEmailTriggerSelect = this.onChangeEmailTriggerSelect.bind(this)
    this.onChangeEmailDateTime = this.onChangeEmailDateTime.bind(this)
    this.onChangeSelections = this.onChangeSelections.bind(this)
    this.onAddField = this.onAddField.bind(this)
    this.onAddEmailField = this.onAddEmailField.bind(this)
    this.removeField = this.removeField.bind(this)
    this.removeEmailField = this.removeEmailField.bind(this)
  };

  componentDidMount() {
    var self = this
    var customerSelectBoxes = []
    var emailSelectBoxes = []

    if (Object.keys(self.state.customerFields).length > 0) {
      Object.keys(self.state.customerFields).map(function (key, index) {
        var obj = {}

        if (self.state.customerFields[key].additional_question) {
          obj.additional_question_value = key
          obj.value = I18n.t("customer_fields")
        } else {
          obj.value = key
        }

        obj.id = "select" + index
        customerSelectBoxes.push(obj)
      });
    }

    if (Object.keys(self.state.emailFields).length > 0) {
      Object.keys(self.state.emailFields).map(function (key, index) {
        var obj = {}

        obj.value = key
        obj.id = "select" + index

        emailSelectBoxes.push(obj)
      });
    }

    self.setState({customerSelectBoxes: customerSelectBoxes, emailSelectBoxes: emailSelectBoxes})
  }

  render(){
    var buttons = this.setButtons();
    return(
      <div className="EmailCampaignBuilder">
        <div className="panel panel-form">
          <LoadingSpinner show={this.state.loading} />
          <ModalButtons loading={this.state.loading} buttons={buttons} />
          <EmailCampaignBuilderNavSteps {...this.state}/>
          <EmailCampaignBuilderWorkspace {...this.state}
            date_format={this.props.date_format}
            time_format={this.props.time_format}
            onChange={this.onChange}
            onChangeEmails={this.onChangeEmails}
            onAddField={this.onAddField}
            onAddEmailField={this.onAddEmailField}
            removeField={this.removeField}
            removeEmailField={this.removeEmailField}
            onChangeInput={this.onChangeInput}
            onChangeSelect={this.onChangeSelect}
            onChangeAdditionalQuestionsSelect={this.onChangeAdditionalQuestionsSelect}
            onChangeCustomerFieldDate={this.onChangeCustomerFieldDate}
            onChangeNumberField={this.onChangeNumberField}
            onChangeEmailTriggerSelect={this.onChangeEmailTriggerSelect}
            onChangeEmailDateTime={this.onChangeEmailDateTime}
            onChangeSelections={this.onChangeSelections}
          />
        </div>
      </div>
    )
  };

  ///////// Change Handlers //////////
  onChange(e) {
    var email_campaign = {...this.state.email_campaign}
    email_campaign[e.target.name] = e.target.value

    this.setState({
      email_campaign: email_campaign
    })
  }

  onChangeEmails(selectedEmails) {
    this.setState({emails: selectedEmails})
  }

  onChangeSelect(e) {
    var customerSelectBoxes = [...this.state.customerSelectBoxes]
    var oldName

    for (let i = 0, ilen = customerSelectBoxes.length; i < ilen; i++) {
      if (customerSelectBoxes[i].id == e.target.id) {
        oldName = customerSelectBoxes[i].value

        if (customerSelectBoxes[i].value == I18n.t('customer_fields')) {
          oldName = customerSelectBoxes[i].additional_question_value
        }

        customerSelectBoxes[i].value = e.target.value
      }
    }

    var fields = { ...this.state.customerFields }

    if (oldName) {
      if (e.target.value != I18n.t('customer_fields')) {
        fields[e.target.value] = null
      }

      delete fields[oldName]
    } else if (e.target.value != I18n.t('customer_fields')) {
      fields[e.target.value] = ""
    }

    this.setState({ customerSelectBoxes: customerSelectBoxes, customerFields: fields })
  }

  onChangeAdditionalQuestionsSelect(e, id) {
    var customerSelectBoxes = [...this.state.customerSelectBoxes]
    var oldName

    for (let i = 0, ilen = customerSelectBoxes.length; i < ilen; i++) {
      if (customerSelectBoxes[i].id == id) {
        oldName = customerSelectBoxes[i].additional_question_value
        customerSelectBoxes[i].additional_question_value = e.target.value
      }
    }

    var fields = { ...this.state.customerFields }

    if (oldName) {
      fields[e.target.value] = null
      delete fields[oldName]
    } else {
      fields[e.target.value] = ""
    }

    this.setState({ customerSelectBoxes: customerSelectBoxes, customerFields: fields })
  }

  onChangeCustomerFieldDate(date, field) {
    var fields = { ...this.state.customerFields }
    var fieldOpt = field.split("_")[1]
    field = field.split("_")[0]

    fields[field] = fields[field] ? fields[field] : {}
    fields[field][fieldOpt] = date

    if (!this.state.allCustomerFields.includes(field) && field != I18n.t("number_of_reservations")) {
      fields[field].additional_question = true
    }

    this.setState({ customerFields: fields })
  }

  onChangeNumberField(e, field) {
    var fields = { ...this.state.customerFields }
    var fieldOpt = field.split("_")[1]
    field = field.split("_")[0]

    fields[field] = fields[field] ? fields[field] : {}
    fields[field][fieldOpt] = e.target.value

    if (!this.state.allCustomerFields.includes(field) && field != I18n.t("number_of_reservations")) {
      fields[field].additional_question = true
    }

    this.setState({ customerFields: fields })
  }

  onChangeInput(e) {
    var fields = {...this.state.customerFields}
    fields[e.target.name] = e.target.value

    if (!this.state.allCustomerFields.includes(field) && field != I18n.t("number_of_reservations")) {
      fields[field].additional_question = true
    }

    this.setState({customerFields: fields})
  }

  onAddField() {
    var customerSelectBoxes = [...this.state.customerSelectBoxes]

    if (customerSelectBoxes.length == this.state.allCustomerFields.length) {
      return null
    }

    var select = {
      id: "select" + (this.state.customerSelectBoxes.length + 1),
      value: undefined
    }
    customerSelectBoxes.push(select)

    this.setState({ customerSelectBoxes: customerSelectBoxes })
  }

  onAddEmailField(email) {
    var emailSelectBoxes = [...this.state.emailSelectBoxes]
    var fields = { ...this.state.emailFields }


    var select = {
      id: "select" + (this.state.emailSelectBoxes.length + 1),
      value: email.name
    }

    fields[email.name] = {}
    emailSelectBoxes.push(select)

    this.setState({ emailSelectBoxes: emailSelectBoxes, emailFields: fields })
  }

  removeField(idx) {
    var customerSelectBoxes = [...this.state.customerSelectBoxes]
    var customerFields = {...this.state.customerFields}
    var select = customerSelectBoxes[idx]

    if(select.additional_question_value) {
      delete customerFields[select.additional_question_value]
    } else {
      delete customerFields[select.value]
    }

    customerSelectBoxes.splice(parseInt(idx), 1)

    for(let i = 0, ilen = customerSelectBoxes.length; i < ilen; i++) {
      customerSelectBoxes[i].id = "select" + (i + 1)
    }

    this.setState({ customerSelectBoxes: customerSelectBoxes, customerFields: customerFields })
  }

  removeEmailField(value, idx) {
    var emailSelectBoxes = [...this.state.emailSelectBoxes]
    var emailFields = {...this.state.emailFields}

    emailSelectBoxes.splice(parseInt(idx), 1)
    delete emailFields[value]

    for(let i = 0, ilen = emailSelectBoxes.length; i < ilen; i++) {
      emailSelectBoxes[i].id = "select" + (i + 1)
    }

    this.setState({ emailSelectBoxes: emailSelectBoxes, emailFields: emailFields })
  }

  onChangeSelections(customers, column) {
    var customerFields = {...this.state.customerFields}

    customerFields[column] = []

    customers.map((customer) => {
      if (customerFields[column]) {
        if (!customerFields[column].includes(customer.column)) {
          customerFields[column].push(customer.column)
        }
      } else {
        customerFields[column] = [customer.column]
      }
    })

    this.setState({customerFields: customerFields})
  }

  onChangeEmailTriggerSelect(e, value) {
    var fields = { ...this.state.emailFields }

    fields[value].trigger = e.target.value

    this.setState({ emailFields: fields })
  }

  onChangeEmailDateTime(value, field) {
    var fields = { ...this.state.emailFields }
    var fieldOpt = field.split("_")[1]
    field = field.split("_")[0]

    fields[field] = fields[field] ? fields[field] : {}
    fields[field][fieldOpt] = value
    this.setState({ emailFields: fields })
  }

  //////// Helpers /////////

  setButtons(){
    if (this.state.step === 'customers_preview') {
      return [
        {
          name: I18n.t('prev'),
          button_classes: ['primary'],
          onClick: (e) => {
            this.stepBack()
            return false;
          },
        },
        {
          name: I18n.t('submit'),
          button_classes: ['primary'],
          onClick: (e) => {
            this.onSave()
            return false;
          },
        },
      ];
    } else if (this.state.step === 'general'){
      return [
        {
          name: I18n.t('prev'),
          button_classes: ['primary'],
          html_attributes: [
            'disabled'
          ],
          onClick: (e) => {
            // this.stepBack()
            return false;
          },
        },
        {
          name: I18n.t('next'),
          button_classes: ['primary'],
          onClick: (e) => {
            this.validateStep()
            return false;
          },
        },
      ];
    } else {
      return [
        {
          name: I18n.t('prev'),
          button_classes: ['primary'],
          onClick: (e) => {
            this.stepBack()
            return false;
          },
        },
        {
          name: I18n.t('next'),
          button_classes: ['primary'],
          onClick: (e) => {
            this.validateStep()
            return false;
          },
        },
      ];
    };
  };

  stepBack(){
    if (this.state.step === 'customers_preview'){
      this.setState({ step: 'email_templates' })
    } else if (this.state.step === 'email_templates'){
      this.setState({ step: 'customer_details' })
    } else if (this.state.step === 'customer_details'){
      this.setState({ step: 'general' })
    }
  };

  setParams(){
    var params = this.state.email_campaign

    params.emails = this.state.emails
    params.customer_fields = this.state.customerFields
    params.email_fields = this.state.emailFields

    return params
  };

  ////// Ajax /////

  validateStep() {
    this.setState({loading: true});
    var params = this.setParams();

    $.ajax({
      type: 'POST',
      url: `/admin/email_campaigns/validate-step`,
      data: {
        email_campaign: params,
        customerSelectBoxes: this.state.customerSelectBoxes,
        emailSelectBoxes: this.state.emailSelectBoxes,
        step: this.state.step,
      }
    }).done((data) => {
      if (!jQuery.isEmptyObject(data.errors)) {
        this.setState({ errors: data.errors, loading: false});
      } else {
        if(this.state.step === 'general'){
          this.setState({step: 'customer_details', errors: [], loading: false});
        } else if(this.state.step === 'customer_details'){
          this.setState({step: 'email_templates', errors: [], loading: false})
        } else if(this.state.step === 'email_templates'){
          this.setState({step: 'customers_preview', errors: [], loading: false, customers: data.customers, table_data: data.table_data})
        }
      };
    });
  };

  onSave(){
    this.setState({loading: true});
    var params = this.setParams();

    $.ajax({
      type: this.props.new_record ? 'POST' : 'PATCH',
      url: this.props.new_record ? this.props.email_campaigns_create_path : this.props.email_campaigns_save_path,
      data: {
        email_campaign: params,
      }
    }).done((data) => {
      if (data.errors) {
        this.setState({
          errors: data.errors,
          loading: false
        });
      } else {
        window.parent.$(window.parent).trigger('email_campaign_saved_successfully', data);
        window.parent.$(window.parent).trigger('updateEmailCampaign');
        this.setState({ loading: false });
        if (parent && parent.refresh_data) {
          if (this.props.new_record == true) {
            parent.refresh_data(I18n.t('email_campaign_created_successfully'));
          } else {
            parent.refresh_data(I18n.t('email_campaign_saved_successfully'));
          }
        }

        if (parent && parent.hide_modal) {
          parent.hide_modal();
        }
      }
    });
  };
};
